<div class="flex flex-wrap ml-4 mt-4 mr-4 gap-4">
  <mat-card
    (click)="cardNavigation('access-management')"
    class="elevated title-card flex-[1_1_320px] min-w-[280px]"
    [ngClass]="{
      'active text-gray-400': currentCard === 'access-management',
      'inactive text-gray-300': currentCard !== 'access-management'
    }"
  >
    <mat-card-content class="!pt-4 !pb-4 !pr-4 !pl-0 h-full">
      <div class="flex flex-row items-center h-full">
        <img
          src="images/administration-access-management/access-management-inactive-icon.svg"
          alt="Access Management"
          class="h-32 pr-1 flex-shrink-0"
          [class.hidden]="currentCard === 'access-management'"
        />
        <img
          src="images/administration-access-management/access-management-active-icon.svg"
          alt="Access Management"
          class="h-32 pr-1 flex-shrink-0"
          [class.hidden]="currentCard !== 'access-management'"
        />
        <div class="flex flex-col h-full w-0 flex-1 justify-between border-l border-gray-300 pl-4 min-w-0">
          <div>
            <div
              class="break-words"
              [ngClass]="{
                'card-title-active': currentCard === 'access-management',
                'card-title-inactive': currentCard !== 'access-management'
              }"
            >
              Access Management
            </div>
            <div class="card-subtitle break-words">
              Create and manage roles, users, and OU collections. Assign roles and OU collections to individual users or
              a user collection.
              <a
                [href]="accessManagementArticleUrl"
                target="_blank"
                class="text-blue-link no-underline hover:underline [font-size:inherit]"
              >
                See how it works >>
              </a>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- <mat-card
    (click)="cardNavigation('team-permissions')"
    class="elevated title-card flex-[1_1_320px] min-w-[280px]"
    [ngClass]="{
      'active text-gray-400': currentCard === 'team-permissions',
      'inactive text-gray-300': currentCard !== 'team-permissions'
    }"
  >
    <mat-card-content class="!pt-4 !pb-4 !pr-4 !pl-0 h-full">
      <div class="flex flex-row items-center h-full">
        <img
          src="images/administration-access-management/team-permissions-inactive-icon.svg"
          alt="Team Permissions"
          class="h-20 pr-1 flex-shrink-0"
          [class.hidden]="currentCard === 'team-permissions'"
        />
        <img
          src="images/administration-access-management/team-permissions-active-icon.svg"
          alt="Team Permissions"
          class="h-20 pr-1 flex-shrink-0"
          [class.hidden]="currentCard !== 'team-permissions'"
        />
        <div class="flex flex-col h-full w-0 flex-1 justify-between border-l border-gray-300 pl-4 min-w-0">
          <div>
            <div
              class="break-words"
              [ngClass]="{
                'card-title-active': currentCard === 'team-permissions',
                'card-title-inactive': currentCard !== 'team-permissions'
              }"
            >
              Team Permissions
            </div>
            <div class="card-subtitle break-words">
              Review detailed team permissions to understand the specific actions each member is authorized to perform.
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card> -->

  <mat-card
    (click)="cardNavigation('audit-log')"
    class="elevated title-card flex-[1_1_320px] min-w-[280px]"
    [ngClass]="{
      'active text-gray-400': currentCard === 'audit-log',
      'inactive text-gray-300': currentCard !== 'audit-log'
    }"
  >
    <mat-card-content class="!pt-4 !pb-4 !pr-4 !pl-0 h-full">
      <div class="flex flex-row items-center h-full">
        <img
          src="images/administration-access-management/audit-log-inactive-icon.svg"
          alt="Audit Log"
          class="h-24 pr-1 flex-shrink-0"
          [class.hidden]="currentCard === 'audit-log'"
        />
        <img
          src="images/administration-access-management/audit-log-active-icon.svg"
          alt="Audit Log"
          class="h-24 pr-1 flex-shrink-0"
          [class.hidden]="currentCard !== 'audit-log'"
        />
        <div class="flex flex-col h-full w-0 flex-1 justify-between border-l border-gray-300 pl-4 min-w-0">
          <div>
            <div
              class="break-words"
              [ngClass]="{
                'card-title-active': currentCard === 'audit-log',
                'card-title-inactive': currentCard !== 'audit-log'
              }"
            >
              Audit Log
            </div>
            <div class="card-subtitle break-words">
              View a comprehensive record of all activities and changes made within the system, detailing various events
              performed by different users.
            </div>
            <div class="card-subtitle break-words mt-2">
              Audit logs are retained for 6 months. Older records are automatically deleted.
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card
    (click)="cardNavigation('global-settings')"
    class="elevated title-card flex-[1_1_320px] min-w-[280px]"
    [ngClass]="{
      'active text-gray-400': currentCard === 'global-settings',
      'inactive text-gray-300': currentCard !== 'global-settings'
    }"
  >
    <mat-card-content class="!pt-4 !pb-4 !pr-4 !pl-0 h-full">
      <div class="flex flex-row items-center h-full">
        <img
          src="images/administration-access-management/global-settings-inactive-icon.svg"
          alt="Global Settings"
          class="h-28 pr-1 flex-shrink-0"
          [class.hidden]="currentCard === 'global-settings'"
        />
        <img
          src="images/administration-access-management/global-settings-active-icon.svg"
          alt="Global Settings"
          class="h-28 pr-1 flex-shrink-0"
          [class.hidden]="currentCard !== 'global-settings'"
        />
        <div class="flex flex-col h-full w-0 flex-1 justify-between border-l border-gray-300 pl-4 min-w-0">
          <div>
            <div
              class="break-words"
              [ngClass]="{
                'card-title-active': currentCard === 'global-settings',
                'card-title-inactive': currentCard !== 'global-settings'
              }"
            >
              Global Settings
            </div>
            <div class="card-subtitle break-words">
              Manage Gopher Buddy extension settings, assign admins, set preferences, and enable/disable the device
              cache.
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
